import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ProgramsAccordion.css';

const API_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5000');

export function ProgramsAccordion() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    fetchPrograms();
  }, []);

  const fetchPrograms = async () => {
    try {
      const res = await fetch(`${API_URL}/api/programs`);
      if (res.ok) {
        const data = await res.json();
        setPrograms(data);
      }
    } catch (error) {
      console.error('Error fetching programs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLearnMore = (programId) => {
    navigate(`/programs/${programId}`);
  };

  if (loading) {
    return (
      <section className="programs-accordion-section">
        <div className="accordion-container">
          <div className="accordion-loading">Loading programs...</div>
        </div>
      </section>
    );
  }

  if (programs.length === 0) {
    return null;
  }

  return (
    <section id="programs" className="programs-accordion-section">
      <div className="accordion-container">
        <h2 className="accordion-section-title">Your Fitness Journey Begins Here</h2>
        <p className="accordion-section-subtitle">
          Discover the perfect program for your fitness journey
        </p>

        <div className="accordion-wrapper">
          {programs.map((program, index) => (
            <div
              key={program.program_id}
              className={`accordion-panel ${!isMobile && activeIndex === index ? 'active' : ''}`}
              onMouseEnter={() => !isMobile && setActiveIndex(index)}
              onClick={() => !isMobile && setActiveIndex(index)}
            >
              <div className="panel-background">
                <img 
                  src={program.image || '/placeholder-program.jpg'} 
                  alt={program.name}
                  crossOrigin="anonymous"
                />
                <div className="panel-overlay"></div>
              </div>

              <div className="panel-content">
                <h3 className="panel-title">{program.name}</h3>
                <p className="panel-description">{program.tagline || program.description}</p>
                <button 
                  className="panel-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLearnMore(program.program_id);
                  }}
                >
                  Learn More
                  <span className="arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProgramsAccordion;
